import { IconType } from "react-icons";
import { FaDiscord, FaSteam } from "react-icons/fa";

import { colors } from "theme/colors";

export type TBoostStep = { step: string; completed: boolean };
export type TBoost = {
  type: string;
  clips: number;
  completed: boolean;
  steps: TBoostStep[];
};

// TODO: swap the Discord action for the AllstarBot server-invite URL once we have one;
// connecting the account is only the first half of that boost.
export const BOOST_COPY: Record<
  string,
  {
    title: string;
    short: string;
    hook: string;
    brand: string;
    Icon: IconType;
    blurb: string;
    learn?: { label: string; to: string };
  }
> = {
  DISCORD_BOT: {
    title: "Add AllstarBot to your Discord server",
    short: "AllstarBot for Discord",
    hook: "Your clips land in your server the moment they are made.",
    brand: colors.discord,
    Icon: FaDiscord,
    blurb:
      "Your clips get sent to your server the moment they are made, so everyone sees them without leaving Discord.",
    learn: { label: "What is AllstarBot?", to: "/allstarbot" },
  },
  STEAM_BOT: {
    title: "Add AllstarBot on Steam",
    short: "AllstarBot on Steam",
    hook: "Your matches reach Allstar sooner, so your clips are ready faster.",
    brand: colors.steam,
    Icon: FaSteam,
    blurb:
      "Your matches come straight to Allstar as they finish, so they process sooner and your clips are ready faster. The bot also sends you your latest matches and highlights.",
  },
};

// TODO: point IN_SERVER_WITH_BOT at the AllstarBot server-invite URL once we have one.
export const STEP_COPY: Record<
  string,
  { label: string; cta: string; to: string }
> = {
  DISCORD_LINKED: {
    label: "Link your Discord account to Allstar",
    cta: "Link your Discord account",
    to: "/connectedaccounts",
  },
  IN_SERVER_WITH_BOT: {
    label: "Add AllstarBot to a server you are in",
    cta: "Add our bot to your server",
    to: "/allstarbot",
  },
  ALERTS_CHANNEL: {
    label: "Pick the channel AllstarBot posts your clips in",
    cta: "Pick your alerts channel",
    to: "/connectedaccounts",
  },
  STEAM_BOT_FRIEND: {
    label: "Add AllstarBot on Steam as a friend",
    cta: "Add our bot on Steam",
    to: "/steam-bot",
  },
};
